import {createSelector} from 'reselect';

// Users redux state
const usersReducerSelector = state => state.users;

// Users List
const usersSelector = createSelector(
    usersReducerSelector,
    usersReducer => usersReducer.get('payload')
);

// Users is fetching
const usersIsFetchingSelector = createSelector(
    usersReducerSelector,
    usersReducer => usersReducer.get('isFetching')
);

// Users error
const usersErrorSelector = createSelector(
    usersReducerSelector,
    usersReducer => usersReducer.get('errorMessage')
);

// Users updated
const usersUpdatedSelector = createSelector(
    usersReducerSelector,
    usersReducer => usersReducer.get('updated')
)

export {
    usersSelector,
    usersIsFetchingSelector,
    usersErrorSelector,
    usersUpdatedSelector
};